import axios from 'axios'
const config = require(`../../../projects/${process.env.PROJECT}/front/configs/envs/${process.env.NODE_ENV}/config.json`)

export const SECURITY_AUTH = 'SECURITY_AUTH'

const state = {
  auth: {
    authenticated: false
  }
}

const getters = {
  isAuthenticated () {
    return state.auth && state.auth.authenticated
  },
  [SECURITY_AUTH]: state => {
    return state.auth
  }
}

const mutations = {
  [SECURITY_AUTH] (state, keycloakAuth) {
    state.auth = keycloakAuth
    if (keycloakAuth) {
      axios.defaults.headers.common = {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer ' + keycloakAuth.token,
        'flexy-country': config['flexy-country'],
        'flexy-city': config['flexy-city'],
        'site-source': config['site-source'],
        'flexy-reparto': config['flexy-reparto'],
        'X-Flexy-Development': 'https://localhost:4200'
      }
    }
  }
}

const actions = {
  authLogin ({ commit }, keycloakAuth) {
    commit(SECURITY_AUTH, keycloakAuth)
  },
  authLogout ({ commit }) {
    state.auth.logout()
    window.sessionStorage.removeItem('isLogged')
    commit(SECURITY_AUTH, null)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/front/store/modules/security.js